import React from "react";

const Table = ({ columns, data }) => {
  return (
    <div className="w-full overflow-x-auto rounded border border-gray-200">
      <table className="table-auto w-full min-w-full whitespace-nowrap divide-y divide-gray-200">
        <thead className="text-[13px] text-gray-700 bg-slate-200">
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                className="px-5 py-2 text-left first:pl-3 last:pr-3"
              >
                {col.headerRender ? col.headerRender() : col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-sm divide-y divide-gray-200">
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="bg-white">
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  className="px-5 py-2 first:pl-3 last:pr-3"
                >
                  {col.render ? col.render(row) : row[col.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
